import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-server-alert-dialog',
	styles: [
		`
			@use 'sass:map';
			@use 'abstracts/colors';

			a,
			a:visited {
				text-decoration: underline;
				color: map.get(colors.$sanus-primary, 900);
				cursor: pointer;
			}
		`,
	],
	template: `
		<app-dialog
			modalTitle="Atenção"
			titleButton="OK"
			[secButton]="false"
			[asAlert]="true"
			(dialogClose)="dialogRef.close()"
			(dialogSave)="dialogRef.close()"
		>
			<div class="fs-xxxs lh-md">
				<p>Planilha enviada para processamento.</p>
				<div class="mt-nano">
					Para acompanhar o status deste envio
					<a (click)="dialogRef.close(true)">clique aqui</a>
				</div>
			</div>
		</app-dialog>
	`,
})
export class BulkActionDialogComponent {
	constructor(public dialogRef: MatDialogRef<BulkActionDialogComponent>) {}
}
